import React from 'react';

var SliderArrow = function SliderArrow() {
  return /*#__PURE__*/React.createElement("svg", {
    "aria-hidden": true,
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 6.5V13.5",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10H7.5",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 13L14.5 10L11.5 7",
    stroke: "#666666",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
SliderArrow.displayName = "SliderArrow";

export { SliderArrow as default };
